<template>
    <CieloLayout :show-merchant-name="true">
        <div class="identification">
            <div class="identification__form">
                <TitleText class="spacing-b-6" level="2">
                    {{ $ml.get('identificationTitle') }}
                </TitleText>
                <CieloInput
                    class="identification__input"
                    :autofocus="false"
                    :borderless="false"
                    name="Email"
                    :label="$ml.get('email')"
                    v-model="email"
                    v-validate="'required|safe-mail'"
                    :data-vv-as="$ml.get('email')"
                    type="email"
                    :error="errors.first('Email')"
                />
                <span class="identification__info" v-text="$ml.get('identificationText')" />
            </div>
        </div>

        <RecurringPaymentWarning class="spacing-b-6" />

        <CieloButton
            class="identification__button"
            :loading="buttonIsLoading"
            @click="goToNextPage"
            aria-label="$ml.get('continue')"
        >
            <span :style="{ 'font-weight': 600, 'font-size': '16px' }" v-text="$ml.get('continue')" />
        </CieloButton>
    </CieloLayout>
</template>

<script>
	import { mapGetters } from 'vuex';

	import SafeMailValidation from '@/helpers/validation-rules/SafeMailValidation';
	import PaymentTypes from '@/models/PaymentTypes';
	import { logEvent } from '@/helpers/cieloLogger';

	const CieloLayout = () => import(
		/* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
	);
	const CieloInput = () => import(
		/* webpackChunkName: "cielo-input" */ '@/components/template/CieloInput'
	);
	import CieloButton from '@/components/template/CieloButton.vue';
	import RecurringPaymentWarning from '@/components/RecurringPaymentWarning';
	import TitleText from '@/components/template/TitleText';

	export default {
		components: {
			CieloLayout,
			CieloInput,
			CieloButton,
			RecurringPaymentWarning,
			TitleText,
		},

		computed: {
			...mapGetters({
				isRecurringPayment: 'recurrentPayment/isRecurringPayment',
			}),

			email: {
				get: (self) => self.$store.state.customer.Email,
				set(value) {
					this.$store.commit('customer/setEmail', value);
				},
			},
		},

		created() {
			if (this.isRecurringPayment) {
				this.$store.commit('payment/setPaymentType', PaymentTypes.CREDIT_CARD);
			}
		},

		mounted() {
            this.$validator.extend('safe-mail', SafeMailValidation);
            this.$validator.validate();
        },

		data() {
			return {
				buttonIsLoading: false,
			};
		},

		methods: {
			async goToNextPage() {
				if (this.buttonIsLoading) return;

				this.buttonIsLoading = true;

				const isValid = await this.$validator.validateAll();

				if (!isValid) {
					this.buttonIsLoading = false;
					return;
				}

				logEvent({
					category: 'data_on_file',
					action: 'dof_identificacao',
					label: 'Usuário visualiza campo com email para preencher.'
				});

				try {
					await this.$store.dispatch('dataOnFile/sendOtp', this.email);
					this.$store.dispatch('pipeline/pushTo', 'CheckOtp');
				} catch (error) {
					console.error('::Error::', error);
				} finally {
					this.buttonIsLoading = false;
				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.identification {
		@media screen and (max-width: 1024px) {
			display: flex;
			flex-direction: column;
			flex: 1 1 auto;
		}
		&__form {
			width: 100%;
			margin-bottom: 24px;
		}

		&__input {
			margin-bottom: 12px;
		}

		&__info {
			font-size: 14px;
			font-weight: 500;
			line-height: 20px;
			color: #454F5C;
		}

		&__button {
			width: 100%;
			height: 44px;

			display: flex;
			justify-content: center;
			align-items: center;

			border-radius: 32px;

			&:hover {
				background-color: #0D5FC0;
			}
		}
	}
</style>
